export const getSourceIcon = (code) => {
    switch (code) {
        case "fl":
            return "/assets/images/typeImages/lead/sources/fb.png";
        case "sapi":
            return "/assets/images/typeImages/lead/sources/sapi.png";
        case "gglw":
            return "/assets/images/google.png";
        case "tiktok":
            return "/assets/images/typeImages/lead/sources/tt.png";
        case "lnkdn":
            return "/assets/images/typeImages/lead/sources/linkedin.png";
        default:
            return "";
    }
};
